import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Alert,
} from '@mui/material';
import FacilitiesAutocomplete from '@/components/FacilitiesAutocomplete/FacilitiesAutocomplete';

const FacilityAccessComponent = ({
  hasAllFacilitiesAccess,
  onHasAllFacilitiesAccessChange,
  roleBasedFacilitiesAccess,
  selectedFacilities,
  onSelectedFacilitiesChange,
  selectedOrganization,
  errors,
}) => {
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <FormControlLabel
          control={
            <Switch
              checked={hasAllFacilitiesAccess}
              onChange={(e) => onHasAllFacilitiesAccessChange(e.target.checked)}
              color='primary'
              disabled={roleBasedFacilitiesAccess}
            />
          }
          label='Grant access to all facilities'
        />
        <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
          {hasAllFacilitiesAccess
            ? 'User has access to all facilities in this organization'
            : 'Select specific facilities for this user'}
        </Typography>
        {hasAllFacilitiesAccess && (
          <Alert severity='info' sx={{ mt: 1 }}>
            Access will apply to future facilities as well.
          </Alert>
        )}
      </Box>

      {!hasAllFacilitiesAccess && (
        <Box sx={{ mb: 2 }}>
          {selectedOrganization && (
            <FacilitiesAutocomplete
              value={selectedFacilities}
              onChange={onSelectedFacilitiesChange}
              label='Facilities'
              placeholder='Search and select facilities...'
              size='small'
              organizationId={selectedOrganization}
              error={!!errors.facilities}
              helperText={errors.facilities}
            />
          )}
        </Box>
      )}

      {!hasAllFacilitiesAccess && selectedFacilities.length === 0 && (
        <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
          No facilities selected. Please select at least one facility for this
          user.
        </Typography>
      )}
    </>
  );
};

export default FacilityAccessComponent;
